import { HttpClient } from '@angular/common/http';
import { Injectable } from '@angular/core';

import { Observable } from 'rxjs';

import { BodyListResponse } from 'src/app/core/models/general/body-list-response';
import { BodyResponse } from 'src/app/core/models/general/body-response';

import { MeritosReconocimientosDTO } from 'src/app/core/models/persona/interfaces';

import { environment } from 'src/environments/environment';

const API_URL = environment.apiUrlPersona;

@Injectable()
export class MeritosReconocimientosService {
  header = new Headers({ 'Content-Type': 'application/json' });

  constructor(private http: HttpClient) {}

  getMeritosReconocimientosService(): Observable<BodyListResponse<MeritosReconocimientosDTO>> {
    return this.http.get<BodyListResponse<MeritosReconocimientosDTO>>(API_URL + '/api/v1/meritosReconocimientos/todos');
  }

  guardarMeritosReconocimientosService(meritosReconocimientosDTO: MeritosReconocimientosDTO): Observable<MeritosReconocimientosDTO> {
    return this.http.post<MeritosReconocimientosDTO>(API_URL + '/api/v1/meritosReconocimientos', meritosReconocimientosDTO);
  }

  getMeritosReconocimientosPorCodigoMeritoReconocimientoService(codigoMeritoReconocimiento: string): Observable<BodyResponse<MeritosReconocimientosDTO>> {
    return this.http.get<BodyResponse<MeritosReconocimientosDTO>>(API_URL + '/api/v1/meritosReconocimientos/' + codigoMeritoReconocimiento);
  }

  getMeritosReconocimientoPorCodigoPersonaService(codigoPersona: string): Observable<BodyListResponse<MeritosReconocimientosDTO>> {
      return this.http.get<BodyListResponse<MeritosReconocimientosDTO>>(API_URL + '/api/v1/meritosReconocimientos/persona/' + codigoPersona);
  }
}
